module.exports = __webpack_public_path__ + "static/media/menu5.876deaed.png";